import React from 'react'

import classNames from 'classnames'
import { LineItemTotals } from '../../../models/line-item'
import { useRegisterManager } from '../../../ng-compat/hooks'
import { useFormatNumber } from '../../helpers/formatNumberHooks'

interface Props {
  totals: LineItemTotals
  type?: 'label' | 'normal'
}

export const LineItemTotalPrice: React.FC<Props> = ({
  totals,
  type = 'label',
}) => {
  const formatNumber = useFormatNumber()
  const registerManager = useRegisterManager()

  const totalPrice = registerManager.isTaxInclusive()
    ? totals.inclusivePrice
    : totals.exclusivePrice

  return (
    <span
      className={classNames('wr-li-cell-summary-price-value', {
        'vd-text-label': type === 'label',
      })}
    >
      {formatNumber(totalPrice)}
    </span>
  )
}
